// Checks that input contains a number and is not just a decimal point
export default (amount: string) => {
  return !Number.isNaN(Number(amount));
};
